module.exports = __webpack_public_path__ + "static/media/product-measurement.a0d1e7a8.svg";